import {
  Box,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { DataLake } from '@finley-technologies/finley-types';

export const AthenaDataPreviewModal = (params: {
  queryDataItems: DataLake.AthenaQueryItemData[];
  onClose: () => void;
  message?: string;
}) => {
  const { queryDataItems, onClose, message } = params;

  const headers = useMemo<string[]>(() => {
    if (queryDataItems.length === 0) {
      return [];
    }
    return Object.keys(queryDataItems[0]);
  }, [queryDataItems]);

  return (
    <Modal
      id="athena-query-save-modal"
      isOpen={queryDataItems.length > 0}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent maxW="fit-content" maxH="4xl" p="2">
        <ModalHeader>
          <Text>
            Queried Data Results: {queryDataItems.length.toLocaleString()} Shown
            Items
          </Text>
          {message && (
            <Text mt="2" fontSize="md" fontWeight="normal">
              {message}
            </Text>
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="5" w="fit-content">
          <Box minW="420px" maxW="1200px" overflow="auto" maxH="2xl">
            <Table>
              <Thead position="sticky" top={0} zIndex="docked">
                <Tr borderBottom="1px">
                  {headers.map((header) => (
                    <Th
                      key={header}
                      whiteSpace="nowrap"
                      border="unset"
                      textAlign="center"
                    >
                      {header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {queryDataItems.map((item, idx) => {
                  const key = `${item[headers[0]]}-${idx}`;
                  return (
                    <Tr key={key} borderBottom="1px">
                      {headers.map((header) => (
                        <Td
                          key={`${header}-${key}`}
                          border="unset"
                          whiteSpace="nowrap"
                        >
                          {header in item ? String(item[header]) : ''}
                        </Td>
                      ))}
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
